import React from 'react';
import { Form, Modal, Button } from "antd"
import { buildFieldType } from 'utils/utils';
import { fields } from "constants/fieldTypes";
import moment from 'moment';

const getField = (field, index, form, key, currentQuestions) => {
    return fields(buildFieldType(field), field, form, `field-step-${key}-${index}`, currentQuestions)
}
const renderFields = (data, form, key, currentQuestions) => {
    return (data.components.map((x, i) => getField(x, i, form, key, currentQuestions())))
}

const getAlert = (info) => {
    let alert = null
    const date = moment();
    const dateValue = moment().set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
    if (date < dateValue) {
        return null
    }
    if (info) {
        const data = info.components.find(x => x.key === 'alert-info')
        if (data) {
            alert = <div className='alert-info'>
                <em className='fal fa-info-circle' />
                <p dangerouslySetInnerHTML={{ __html: data.content }}></p>
            </div>
        }
    }

    return alert
}

export default function ModalInput({ btnOk, btnCancel, modalProps, form, currentQuestions }) {
    const info = modalProps.components.find(x => x.key === 'vigenciaDeTuSeguro')
    const data = info.components[0]
    const alert = getAlert(info)
    return modalProps && (
        <Modal
            title={info.title}
            visible={true} footer={null}
            closable={false} maskClosable={false}
            wrapClassName={`modal-confirm ${info.customClass}`}
            width={450}
        >
            <div className='modal-custom-info-content'>
                <p>{data.legend}</p>
                <Form form={form}>{renderFields(data, form, info.key, currentQuestions)}
                    {alert}
                    <div className='modal-custom-info-content-footer'>
                        <Button className='ant-btn-text c-4 ant-btn-size-xs margin-s'
                            onClick={() => { btnCancel() }}>
                            Cancelar
                        </Button>
                        <Button className='ant-btn-solid c-2 ant-btn-size-xs margin-s'
                            onClick={() => btnOk()}>
                            Aceptar
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    )
}